import { useEffect, useState } from "react";
import api from "./api";

/**
 * Fetches the editable Home content from /api/content/home.
 * Returns { content, ready } where content is null until loaded; once loaded,
 * components can resolve `content?.x?.es ?? t.fallback`.
 */
export function useHomeContent() {
  const [content, setContent] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let mounted = true;
    api.get("/content/home")
      .then(({ data }) => { if (mounted) setContent(data); })
      .catch(() => { /* fall back to i18n defaults */ })
      .finally(() => { if (mounted) setReady(true); });
    return () => { mounted = false; };
  }, []);

  return { content, ready };
}

/**
 * Pick a bilingual field from a CMS object, with i18n fallback.
 * fieldName is the base (e.g. "title"); we read `${fieldName}_${lang}`.
 */
export function pick(obj, fieldName, lang, fallback) {
  if (obj && typeof obj === "object") {
    const v = obj[`${fieldName}_${lang}`];
    if (v != null && String(v).length > 0) return v;
  }
  return fallback;
}
